export default "__VITE_ASSET__C7MZ$hW___"